import React from 'react';
import { Button, Input } from 'reactstrap';
import { Graph, SideBar, ReportGuide} from '../parts/index';
import {axiosApi} from '../../assets/axiosAPI';
import { API_PATH, LOGOUT } from '../../assets/const';
import {getSessionInfoGeneral} from '../../assets/common';
import { PAGE_TITLE_BASE, PAGE_TITLE_ITEM} from '../../assets/const';

const GET_BASE = API_PATH + "/resources/mrtgfile/base";
const GET_ITEM = API_PATH + "/resources/mrtgfile/item";
const GET_GRAPH = API_PATH + "/resources/graph";

export default class Report extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            pageTitle:"",
            //グラフデータ
            dailyGraph:"",
            weeklyGraph:"",
            monthlyGraph:"",
            yearlyGraph:"",
            //グラフの検索条件
            period:"",
            itemName: "",
            deviceName:"",
            baseName:"",
            graphType:"",
            //サイドバーの項目
            sideBarContents:[]
        }
    }

    componentDidMount(){
        getSessionInfoGeneral();
        this.initializeScreen();
    }

    initializeScreen = () =>{
        // //グラフ取得期間のENDを当日に設定
        // const _today = new Date();
        // const _period = _today.getFullYear() + "-" 
        //                 + ('0' + (_today.getMonth() + 1)).slice(-2) + "-" 
        //                 + ('0' + _today.getDate()).slice(-2);
        
        // //画面に反映
        // document.getElementsByClassName("report-period-input")[0].value = _period;      
        
        //サイドバーの情報を取得
        if(this.props.pathName === "ReportBase"){
            //CASE:拠点別グラフ
            axiosApi
                .get(GET_BASE)
                .then((response) =>{
                    const _responseData = response.data;
                    const _baseList = this.changeReportBaseJsonKeyName(_responseData.baseList);
                    this.setState({
                        pageTitle:PAGE_TITLE_BASE,
                        sideBarContents:_baseList
                    })
                })
                .catch((error) => {
                    if(error.response){
                        //通信時のエラー
                        const _statusCode = error.response.status;
                        if(_statusCode === 401 || _statusCode === 403){
                            //セッションまたは権限なし
                            alert("セッションまたは権限がありません。ログイン画面へ戻ります。");
                            window.location.href = LOGOUT;
                        }else{
                            //入らない処理
                            alert("ログイン画面へ戻ります。");
                            window.location.href = LOGOUT;
                        }
                    }else{
                        //レスポンス取得後のエラー or 通信失敗時のエラー
                        alert("予期せぬエラーが発生しました。ログイン画面へ戻ります。");
                        window.location.href = LOGOUT;
                    }    
                })        
        }else if(this.props.pathName === "ReportItem"){
            //CASE:項目別グラフ
            axiosApi
            .get(GET_ITEM)
            .then((response) =>{
                const _responseData = response.data;
                const _sideBarContents = this.changeReportItemJsonKeyName(_responseData.itemList);
                this.setState({
                    pageTitle:PAGE_TITLE_ITEM,
                    sideBarContents:_sideBarContents
                })
            })
            .catch((error) => {
                if(error.response){
                    //通信時のエラー
                    const _statusCode = error.response.status;
                    if(_statusCode === 401 || _statusCode === 403){
                        //セッションまたは権限なし
                        alert("セッションまたは権限がありません。ログイン画面へ戻ります。");
                        window.location.href = LOGOUT;
                    }else{
                        //入らない処理
                        alert("ログイン画面へ戻ります。");
                        window.location.href = LOGOUT;
                    }
                }else{
                    //レスポンス取得後のエラー or 通信失敗時のエラー
                    alert("予期せぬエラーが発生しました。ログイン画面へ戻ります。");
                    window.location.href = LOGOUT;
                }              
            })          
        }else{
            //Routeがうまくいっていないとき
            console.log("Routingエラー");
        }
    }

    //サイドバーの汎用化のために取得したJSONのキーを修正
    changeReportBaseJsonKeyName = (baseList) =>{
        baseList.forEach(baseList => {
            baseList.firstElement = baseList.baseName;
            baseList.secondList = baseList.deviceList;
            baseList.secondList.forEach(secondList =>{
                secondList.secondElement = secondList.deviceName;
                secondList.thirdList = secondList.itemList;
                secondList.thirdList.forEach(thirdList => {
                    thirdList.thirdElement = thirdList.itemName;
                    delete thirdList.itemName;
                })
                delete secondList.deviceName;
                delete secondList.itemList;
            })
            delete baseList.baseName;
            delete baseList.deviceList;
        })
        return baseList;
    }

    //サイドバーの汎用化のために取得したJSONのキーを修正
    changeReportItemJsonKeyName = (itemList) =>{
        itemList.forEach(itemList => {
            itemList.firstElement = itemList.itemName;
            itemList.secondList = itemList.baseList;
            itemList.secondList.forEach(secondList =>{
                secondList.secondElement = secondList.baseName;
                secondList.thirdList = secondList.deviceList;
                secondList.thirdList.forEach(thirdList => {
                    thirdList.thirdElement = thirdList.deviceName;
                    delete thirdList.deviceName;
                })
                delete secondList.baseName;
                delete secondList.deviceList;
            })
            delete itemList.itemName;
            delete itemList.baseList;
        })
        return itemList;
    }

    //サイドバーで1階層目の要素をクリックしたときの処理
    clickTopLayerInfo = (event) =>{
        const middleLayers = event.target.parentNode.getElementsByClassName("middleLayer");
        middleLayers.forEach(middleLayer => {
            middleLayer.classList.toggle("is-open");
        })
    }

    //サイドバーで2階層目の要素をクリックしたときの処理
    clickMiddleLayerInfo = (event) =>{
        const bottomLayers = event.target.parentNode.getElementsByClassName("bottomLayer");
        bottomLayers.forEach(bottomLayer => {
            bottomLayer.classList.toggle("is-open");
        })
    }

    //サイドバーで3階層目の要素をクリックしたときの処理
    clickBottomLayerInfo = (event) =>{
        let getGraphParam = {
            period:"",
            itemName: this.state.itemName,
            deviceName:this.state.deviceName,
            baseName:this.state.baseName,
            graphType:"",
            isLastDailyGraph:false
        };

        //サイドバー3階層目の色を変更
        const ClickedItem = document.getElementsByClassName("ClickedSideBarItem");
        if(ClickedItem.length !== 0){
            ClickedItem[0].classList.remove("ClickedSideBarItem");
        }
        event.target.classList.add("ClickedSideBarItem");

        this.setReportPeriodDate(getGraphParam);
        console.log("getGraphParam:"+getGraphParam.period);

        const _middleLayer = event.target.parentNode.parentNode;
        const _topLayer = _middleLayer.parentNode;

        if(this.state.pageTitle === PAGE_TITLE_BASE){
            getGraphParam.baseName = _topLayer.getElementsByClassName("topLayerContent")[0].dataset["value"];
            getGraphParam.deviceName = _middleLayer.getElementsByClassName("middleLayerContent")[0].dataset["value"];
            getGraphParam.itemName = event.target.dataset["value"];
        }else if(this.state.pageTitle === PAGE_TITLE_ITEM){
            getGraphParam.itemName = _topLayer.getElementsByClassName("topLayerContent")[0].dataset["value"];
            getGraphParam.baseName = _middleLayer.getElementsByClassName("middleLayerContent")[0].dataset["value"];
            getGraphParam.deviceName = event.target.dataset["value"];
        }else{
            //想定していないpageTitle
            console.log("pageTitleにてエラー");
        }

        this.fetchGraph(getGraphParam);
        //console.log(getGraphParam);

        document.getElementsByClassName("report-period")[0].style.visibility = "visible";
        document.getElementsByClassName("report-report").forEach(element =>{
        element.style.visibility = "visible";
        });
    }

    //日付更新ボタン押下時の処理。
    //Stateと日付欄から値を取得して、グラフ取得。
    clickUpdatePeriod = () =>{
        let getGraphParam = {
            period:"",
            itemName: this.state.itemName,
            deviceName:this.state.deviceName,
            baseName:this.state.baseName,
            graphType:"",
            isLastDailyGraph:false
        };

        this.setReportPeriodDate(getGraphParam);
        console.log("getGraphParam:"+getGraphParam.period);

        this.fetchGraph(getGraphParam);
    }


    //最新のグラフへ更新ボタン押下時の処理。
    //Stateから値を取得して、グラフ取得。
    clickUpdateLastDailyGraph = () =>{
        let getGraphParam = {
            period:"",
            itemName: this.state.itemName,
            deviceName:this.state.deviceName,
            baseName:this.state.baseName,
            graphType:"0",　　　　　　　//グラフ取得期間に指定がないのでグラフ種類（グラフの取得期間の設定）を0へ。
            isLastDailyGraph:true
        };

        this.fetchGraph(getGraphParam);
        //console.log(getGraphParam);
    }

    //グラフ取得処理
    fetchGraph = (GraphParam) =>{
        let dailyGraphData = "";
        let weeklyGraphData = "";
        let monthlyGraphData = "";
        let yearlyGraphData = "";

        axiosApi
            .get(GET_GRAPH, {
                params: {
                    baseName:GraphParam.baseName,
                    deviceName:GraphParam.deviceName,
                    itemName:GraphParam.itemName,
                    date:GraphParam.period,
                    graphType:GraphParam.graphType
                }
            })
            .then((response) => {
                const _responseData = response.data;
                //console.log(_responseData);
                if (GraphParam.isLastDailyGraph){
                    //「最新のグラフへ更新」の時は、Dailyのグラフだけ更新する
                    dailyGraphData = _responseData.dailyGraph;
                    weeklyGraphData = this.state.weeklyGraph;
                    monthlyGraphData = this.state.monthlyGraph;
                    yearlyGraphData = this.state.yearlyGraph;
                }else{
                    dailyGraphData = _responseData.dailyGraph;
                    weeklyGraphData = _responseData.weeklyGraph;
                    monthlyGraphData = _responseData.monthlyGraph;
                    yearlyGraphData = _responseData.yearlyGraph;
                }

                this.setState({
                    //グラフデータ
                    dailyGraph:dailyGraphData,
                    weeklyGraph:weeklyGraphData,
                    monthlyGraph:monthlyGraphData,
                    yearlyGraph:yearlyGraphData,
                    //グラフの検索条件
                    period:GraphParam.period,
                    itemName: GraphParam.itemName,
                    deviceName:GraphParam.deviceName,
                    baseName:GraphParam.baseName,
                    graphType:GraphParam.graphType
                })
            })
            .catch((error) => {
                if(error.status){
                    //通信時のエラー
                    const _statusCode = error.response.status;
                    if (_statusCode === 400){
                        //BadRequest
                        alert("グラフを表示するのに十分な情報がありません。");
                    }else if(_statusCode === 401 || _statusCode === 403){
                        //セッションまたは権限なし
                        alert("セッションまたは権限がありません。ログイン画面へ戻ります。");
                        window.location.href = LOGOUT;
                    }else{
                        //入らない処理
                        alert("ログイン画面へ戻ります。");
                        window.location.href = LOGOUT;
                    }
                }else{
                    //レスポンス取得後のエラー or 通信失敗時のエラー
                    alert("予期せぬエラーが発生しました。ログイン画面へ戻ります。");
                    window.location.href = LOGOUT;
                }   
            })
    }

    //日付チェック処理
    //０．空欄と数字8文字チェック
    //１．入力値が正しくない場合、日付をさかのぼったグラフを表示
    //２．入力できるのは過去1年まで
    checkDate = (inputDate) =>{
        //現在日を取得
        const now = new Date();
        //1年前の日付
        let lastYear = new Date();
        lastYear.setFullYear(lastYear.getFullYear() -1);

        //日付をさかのぼったグラフ取得時は、日付を見ないので、空で設定
        const nullDate = "";
        //空欄かチェック
        if(!inputDate){
            return nullDate;
        }
        //数字8文字かチェック     
        if(!inputDate.match(/^\d{8}$/)){
            //形式不備の場合、
            return nullDate;
        }
        //入力値が正しい日付かチェック
        const year = inputDate.substring(0,4);
        const month = inputDate.substring(4,6);
        const day = inputDate.substring(6,8);
        const dtInputDate = new Date(year, month-1, day);
        if(dtInputDate.getFullYear() !== year-0
        || dtInputDate.getMonth() + 1 !== month-0){
            //形式不備の場合、
            return nullDate;
        }
        //過去1年以内かチェック
        if(lastYear <= dtInputDate && dtInputDate <= now){
            //後続処理で使う日付形式に変換 yyyy-MM-dd
            const rtDate = year + "-" + month + "-" + day;
            return rtDate;
        }else{
            return nullDate;
        }
    }

    setReportPeriodDate = (getGraphParam) =>{
        //最新のグラフENDの日付を取得
        const _inputReportPeriodDate = document.getElementsByClassName("report-period-input")[0].value;
        const _reportPeriodDate = this.checkDate(_inputReportPeriodDate);
        if(_reportPeriodDate){
            getGraphParam.period = _reportPeriodDate.substring(0,4) + "/" + _reportPeriodDate.substring(5,7) + "/" + _reportPeriodDate.substring(8,10) + " 00:00:00";
        }

        //グラフ種類　0:日付指定以外、1:日付指定
        //初回表示とグラフ取得期間に指定がないときにグラフ種類を0へ。
        if (getGraphParam.period){
            getGraphParam.graphType = "1"
        }else{
            getGraphParam.graphType = "0"
            //現在日からさかのぼった表示なので、画面のフォームを空欄にする
            document.getElementsByClassName("report-period-input")[0].value = "";
        }
    }

    render(){
        return(
            <div>
                <h1 className="PageTitle">{this.state.pageTitle}</h1>
                <div className="report main">
                <p style={{marginLeft:"1em"}}>下記のメニューを順番に選択して、対象のグラフを表示してください。</p>
                <div style={{marginLeft:"1em"}}>
                    <ReportGuide pageTitle={this.state.pageTitle} />
                </div>
                    <div className='report-sideBar'>
                        {this.state.sideBarContents.map((value, index) => {
                            return <SideBar firstElement={value.firstElement}
                                            secondList={value.secondList}
                                            index={index}
                                            clickTopLayerInfo = {this.clickTopLayerInfo}
                                            clickMiddleLayerInfo = {this.clickMiddleLayerInfo}
                                            clickBottomLayerInfo={this.clickBottomLayerInfo}/>
                        })}
                    </div>
                    <div className='report-main'>
                        <div className="report-period">
                            グラフ取得日：<Input type="text" className="report-period-input" style={{ width: "15.5em", display: "inline" }}></Input>
                            <Button onClick={this.clickUpdatePeriod} color='primary' style={{marginLeft:"6em"}}>更新</Button>
                            <div>
                                表示する日付を変更する場合は、上記にYYYYMMDD形式(例：20210101)で日付を入力してください。<br/>
                                入力できるのは過去1年までの年月日です。<br/>
                                空欄の場合や入力値が正しくない場合、現在時刻から1日前まで遡ったグラフを表示します。
                            </div>
                        </div>
                        <div className="report-report">
                            <div>
                                <h2 style={{display:"inline-block"}}>Daily</h2>
                                <Button onClick={this.clickUpdateLastDailyGraph} color='primary' style={{display:"inline-block", marginLeft:"16em"}}>最新のグラフへ更新</Button>
                            </div>
                            <div>1日のグラフ</div>
                            <Graph binaryGraph={this.state.dailyGraph} />
                        </div>
                        <div className="report-report">
                            <h2>Weekly</h2>
                            <div>1週間のグラフ</div>
                            <Graph binaryGraph={this.state.weeklyGraph} />
                        </div>
                        <div className="report-report">
                            <h2>Monthly</h2>
                            <div>1か月間のグラフ</div>
                            <Graph binaryGraph={this.state.monthlyGraph} />
                        </div>
                        <div className="report-report">
                            <h2>Yearly</h2>
                            <div>1年間分のグラフ</div>
                            <Graph binaryGraph={this.state.yearlyGraph} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
